module.exports = __webpack_public_path__ + "ff6987cf569e8ae8e2fe61b97771973f.fbx";